import React from 'react'

import PropTypes from 'prop-types'

import { Card, CardMedia, Typography, IconButton } from '@material-ui/core'
import { observer } from 'mobx-react'
import { Link as RouterLink } from 'react-router-dom'

import { DoubleChevronRight } from 'shared/icons'

import style from './CtaCard.module.scss'

const CtaCard = ({ backgroundColor, image, primary, secondary, to, ...rest }) => {
  return (
    <Card
      className={style.CtaCard}
      style={{ backgroundColor }}
      {...rest}
    >
      <CardMedia image={image} className={style.CardMedia}>
        <Typography variant="h4">{primary}</Typography>
        <IconButton
          color="inherit" variant="outlined" className={style.GoButton}
          component={RouterLink} to={to}
          alt={secondary}
        >
          <DoubleChevronRight />
        </IconButton>
      </CardMedia>
    </Card>
  )
}

CtaCard.propTypes = {
  /** Card background color */
  backgroundColor: PropTypes.string.isRequired,
  /** Card background image */
  image: PropTypes.string.isRequired,
  /** Primary CTA text (header) */
  primary: PropTypes.string.isRequired,
  /** Secondary CTA text (button) */
  secondary: PropTypes.string.isRequired,
  /** Path for router link */
  to: PropTypes.string.isRequired,
}

export default observer(CtaCard)
